import roadmapSprite from '@/assets/sprite/roadmap-sprite.svg';
import { GameResult as GameResultEnum } from '@/models/games/roulette/GameResult';
import { Bet } from '@/modules/report/slice/betRecord';
import { isBitActive } from '@/utils/bitwiseUtil';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useMemo } from 'react';

type RouletteResultRecordPanelProps = {
    bet: Bet;
};
export const UltraRouletteResultRecordPanel = (
    props: RouletteResultRecordPanelProps
) => {
    const { bet } = props;
    const result = useMemo(() => {
        return JSON.parse(bet.Result);
    }, [bet.Result]);
    const color = useMemo(() => {
        if (isBitActive(bet.WinSlot, GameResultEnum.RRZero)) {
            return '#FF4F4F';
        } else if (isBitActive(bet.WinSlot, GameResultEnum.RRRed)) {
            return '#c70000';
        } else if (isBitActive(bet.WinSlot, GameResultEnum.RRBlack)) {
            return '#6C6C6C';
        }
    }, [bet.WinSlot]);

    const hasMultipier = useMemo(() => result.RM > 3000, [result]);

    return (
        <>
            <Stack justifyContent="center">
                {hasMultipier && (
                    <Box
                        sx={{
                            width: '2rem',
                            height: '2rem',
                            border: '2px solid #FFEBB4',
                            boxShadow:
                                '0px 0px 5px 0px #FFD748 inset, 0px 0px 5px 0px #FFD748',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            bgcolor={color}
                            height={'1.25rem'}
                            width={'1.25rem'}
                            display={'flex'}
                            justifyContent={'center'}
                            alignContent={'center'}
                            alignItems={'center'}
                            borderRadius={'0.125rem'}
                            // border={`2px solid ${
                            //     resultToColor() == '#6C6C6C' ? '#333' : 'unset'
                            // }`}
                            fontSize={'0.75rem'}
                        >
                            {result.R}
                        </Box>
                        <Box className="ultra-roulette-result-detail-multipier-box">
                            <svg width="100%" height="100%">
                                <use
                                    xlinkHref={`${roadmapSprite}#roulette__ultra_multipier__${result.RM}`}
                                    key={`${result.RM}-label`}
                                />
                            </svg>
                        </Box>
                    </Box>
                )}
                {!hasMultipier && (
                    <Box
                        bgcolor={color}
                        height={'1.25rem'}
                        width={'1.25rem'}
                        display={'flex'}
                        justifyContent={'center'}
                        alignContent={'center'}
                        alignItems={'center'}
                        borderRadius={'0.125rem'}
                        // border={`2px solid ${
                        //     resultToColor() == '#6C6C6C' ? '#333' : 'unset'
                        // }`}
                        fontSize={'0.75rem'}
                    >
                        {result.R}
                    </Box>
                )}
            </Stack>
        </>
    );
};
